import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "TabMenu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["SectionButton", { Selected: _ctx.reviewingPageSelected }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateToReviewingPage && _ctx.navigateToReviewingPage(...args)))
    }, [...(_cache[3] || (_cache[3] = [
      _createElementVNode("i", { class: "lnr-eye" }, null, -1 /* CACHED */),
      _createElementVNode("span", { class: "SectionButtonText" }, "Reviewing", -1 /* CACHED */)
    ]))], 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass(["SectionButton", { Selected: _ctx.historyPageSelected }]),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navigateToHistoryPage && _ctx.navigateToHistoryPage(...args)))
    }, [...(_cache[4] || (_cache[4] = [
      _createElementVNode("i", { class: "lnr-clipboard-text" }, null, -1 /* CACHED */),
      _createElementVNode("span", { class: "SectionButtonText" }, "History", -1 /* CACHED */)
    ]))], 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass(["SectionButton", { Selected: _ctx.quickGuidePageSelected }]),
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.navigateToQuickGuidePage && _ctx.navigateToQuickGuidePage(...args)))
    }, [...(_cache[5] || (_cache[5] = [
      _createElementVNode("i", { class: "lnr-book" }, null, -1 /* CACHED */),
      _createElementVNode("span", { class: "SectionButtonText" }, "Quick guide", -1 /* CACHED */)
    ]))], 2 /* CLASS */)
  ]))
}